<div class="footer-content">
    <p class="mb-0">Copyright © 2022 Treedev. {{"All rights reserved" | translate}}.</p>
    <span>
        <a href="" class="text-gray me-3">{{"Terms & Conditions" | translate}}</a>
        <a href="" class="text-gray">{{"Privacy & Policy" | translate}}</a>
    </span>
</div>